import React from "react";
import { StyleSheet, View, Text } from "@react-pdf/renderer";
import generalStyle from "../GeneralStyles";

export const BodyHeader = ({ themeData, children }) => {
  const bodyBlock = StyleSheet.create({
    bodyHeader: {
      backgroundColor: themeData.primary,
      color: "white",
      ...generalStyle.inLineBlocks,
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: 12,
      padding: "6 8 6",
      borderRadius: 3,
      marginTop: 15,
    },
  });

  return (
    <View data-testid="body-header" style={bodyBlock.bodyHeader}>
      {children}
    </View>
  );
};

export const BodyHeaderItem = ({ title, subTitle }) => {
  const bodyHeaderItemStyle = StyleSheet.create({
    title: {
      ...generalStyle.semiBold,
      marginRight: 5,
    },
  });

  return (
    <View style={generalStyle.inLineBlocks}>
      <Text style={bodyHeaderItemStyle.title}>{title}</Text>
      <Text>{subTitle}</Text>
    </View>
  );
};
